<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main-fluid";
import Calendario from "@components/Calendario";

export default {
  page: {
    title: "Calendário",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    Layout,
    Calendario
  },
  data() {
    return {
      title: "Calendário",
      items: [
        {
          text: "Página inicial",
          href: "/"
        },
        {
          text: "Calendário",
          href: "/Calendario",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <div class="card">
        <div class="card-body">
          <Calendario />
        </div>
      </div>
    </div>
  </Layout>
</template>
